import React, { useEffect } from "react";
import SummaryTable from "./SummaryTable";
import useReviewStatusGroup from "../hooks/useReviewStatusGroup";
import { useFilterContext } from "../../../hooks/FilterContext";

const ReviewStatusGroup = () => {
    const { filter } = useFilterContext();
    const { search, ...rest } = useReviewStatusGroup(filter);
    const { data, error, isLoading, isFetching } = rest;

    useEffect(() => {
        const delayedRequest = setTimeout(() => search(filter), 500);
        return () => clearTimeout(delayedRequest);
    }, [ filter ]);


    return <SummaryTable label="Summary" data={data} error={error} isLoading={isLoading === true || isFetching === true} />
};

export default ReviewStatusGroup;